import React from "react";
import dayjs from "dayjs";
import Sidbarv2 from "../../Workspace-v2/Sidbarv2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Badge from "@mui/material/Badge";
import Paper from "@mui/material/Paper";
import consolidlogo from "../../../assets/consolidlogo.svg";
// import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import "./../../Workspace-v2/sidebarv2.css";
import PropTypes from "prop-types";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { Navbar } from "../../../Components/Navbar";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { ReactComponent as MenuDotIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import {
  deleteControlFS,
  getAllIR,
  getCompanyConsol,
  getOneAccessWorkspacedata,
  getWorkspace,
  saveFsData,
  fetchInvestmentRegistersConsol,
  updateFsData,
} from "../ApiServices/apiHandler";
import { useState } from "react";
import axios from "axios";
import {
  getCompanybyId,
  getPrepareConsole,
  getProjectsConsol,

} from "../../../Console/Component/services/apiHandler";
import swal from "sweetalert";
import SubsidiarySelectModal from "../Modal/selectFsGrpModal";
import PreSetWorkspaceModal from "../Modal/presetWorkspaceModal";
import CreateFsModal from "../Modal/createFsModal";
import CompareFs from "../Modal/compareFsModal";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { fetchPrepareConsoleData } from "../../../redux/actions/actionPrepareConsole";
import { selectPrepareConsole } from "../../../redux/actions/actionMiscellaneous";
import { fetchWorkspacePrepareConsoleData } from "../../../redux/actions/actionWorkspacePrepareConsole";
import { useEffect } from "react";
import LoaderTwo from "../../../Components/Common/Loader/LoaderTwo";
import { investeeData } from "../ApiServices/apiHandler";
import TranslateFSModal from "../Modal/TranslateFSModal";

import InputGroup from "../../../myfin_v2/elements/InputGroup";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import Sidebar from "../../../myfin_v2/elements/Sidebar";
import workSpaceCss from "../../../myfin_v2/css/workSpaceOverView.module.css"
import FSSideMenu from "../../../myfin_v2/components/fs/FSSideMenu";
import FSTopBar from "../../../myfin_v2/components/fs/FSTopBar";

// import { ReactComponent as DeleteIcon} from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import Modal from "../../../../src/myfin_v2/elements/Modal";
import modalcss from "../../../../src/myfin_v2/css/modal.module.css";
import { ReactComponent as DeleteIconWhite } from "../../../myfin_v2/assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/editPri.svg";
// import  { useState, useEffect, useContext } from "react";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { set } from "react-hook-form";
import { softDeleteNotesData } from "../../../services/api/apiHandler";
import { socket } from "../../../services/socket/socket";

import { motion } from "framer-motion";
import commoncss from "../../../myfin_v2/css/common.module.css"
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css"
import { clearSoftDeleteNotes } from "../../../redux/actions/TemplateTabs/actionDN";

import StatusIndicator from "../../../myfin_v2/elements/StatusIndicator";
import standalonecss from "../../../myfin_v2/css/standalone.module.css";
import bookclosuretablecss from "../../../myfin_v2/css/bookclosuretable.module.css";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import MuiModal from "@mui/material/Modal";
import MuiCloseIcon from "@mui/icons-material/Close";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Consolidation = () => {
   const location = useLocation();
  let a = location.pathname;
  let w_id = a.split("/");
  console.log("Path:", location.pathname);
  console.log("Split:", w_id);
  const user = JSON.parse(localStorage.getItem('user'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [fsId, setFSID] = useState("");
  const handleIdClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setFSID(id);
  };
  const [showTranslateFSModal, setShowTranslateFSModal] = useState(false);
  const handleIdClose = () => {
    setAnchorEl(null);
  };

  const idopen = Boolean(anchorEl);
  const id = idopen ? "simple-popover" : undefined;

  // const [value, setValue] = React.useState<Dayjs | null>(dayjs('2022-04-17'));

  const [open, setOpen] = React.useState(false);
  const [openCompare, setOpenCompare] = useState(false);
  const handleOpen = () => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("Warning", "You Don't have Access to Create Console FS", "warning");
    } else {
      setOpen(true);
    }
  }
  const handleClose = () => setOpen(false);
  const handleClosePreset = () => openPreset(false);
  const handleOpenCompare = () => {
    setOpenCompare(true);
  };
  const auth = localStorage.getItem("auth_token");
  const [currentFY, setCurrentFY] = useState(null);
  const [previousFY, setPreviousFY] = useState(null);
  const [isopen, setIsOpen] = React.useState(false);
  const [openCurrent, setOpenCurrent] = useState(false);
  const [openPrevious, setOpenPrevious] = useState(false);
  const handleIsClose = () => {
    setOpenCompare(false);
    setIsOpen(false);
    setPrepareConsoleID();
  };
  const [oneAccess, setOneAccess] = useState("");
  const [value, setValue] = React.useState(0);
  const [allpreconsoldata, getAllPreConsolCompany] = useState([]);
  const [allCompany, setAllCompany] = useState([]);
  const [allIr, setAllIR] = useState([]);
  const [selectedIr, setSelectedIr] = useState([]);
  const [preset, openPreset] = useState(false);
  const [projectsData, setProjectsData] = useState([]);
  const [company, setCompany] = useState("");
  const [workspaceData, setWorkspace] = useState([]);
  const [uploadPresetID, setUploadPresetId] = useState("");
  const [prepareConsoleId, setPrepareConsoleID] = useState("");
  const [fieldModal, setField] = useState("");
  const [presetId, setPresetId] = useState("");
  const [presetIdData, getPreConsole] = useState("");
  const [editOpen, setEditOpen] = useState(false);
  const [renameModalOpen, setRenameModalOpen] = useState(false);
  const [selectedConsolId, setSelectedConsolId] = useState("");
  const [selectedConsolName, setSelectedConsolName] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteConsolId, setDeleteConsolId] = useState("");
  const prepareConsole_data = useSelector(
    (state) => state.PrepareConsoleReducer
  );
  const workspacePrepareConsol = useSelector(
    (state) => state.WorkspacePrepareconsolReducer
  );
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    if (workspacePrepareConsol.isSuccess === false || workspacePrepareConsol.set_payload !== w_id[2]) {
      dispatch(fetchWorkspacePrepareConsoleData(w_id[2]));
    }
  }, [w_id[2]])

  React.useEffect(() => {
    getOneAccessWorkspace();
    GetCompany();
    getAllIrData();
    // getPreConsole();
    fetchPreConsole();
    getCompanyData();
    getPrepareConsole();
    fetchWorskSpace();
    if (prepareConsole_data.isSuccess === false || prepareConsole_data.set_payload !== prepareConsoleId) {
      dispatch(fetchPrepareConsoleData(prepareConsoleId));
    }

    // fetchInvestCompany();
  }, [w_id[2]]);

  const [fsData, setFsData] = useState({
    consol_name: "",
    parent_company: "",
    link_ir: "",
    FSType: "standalone",   
    consolID: "",
    current_yr: "",
    previous_yr: "",
  });

  const GetCompany = async () => {
    const res = await getCompanyConsol();
    if (res?.status === 200) {
      setAllCompany(res.data.getCompany);
    }
  };
  const uploadPreset = (field, preset_id) => {
    openPreset(true);
    if (field === "empty") {
      setField(field);
      setPresetId(preset_id);
    }
  };

  const getInvestmentRegisterName = (dat) => {
  if (dat?.investmentData?.name) {
    return dat.investmentData.name;
  }

  if (dat?.investmentRegisterID && allIr?.length) {
    const ir = allIr.find(
      (item) => item._id === dat.investmentRegisterID
    );
    return ir?.name || "NA";
  }

  return "NA";
};


  let history = useHistory();
  const getOneAccessWorkspace = async () => {
    const res = await getOneAccessWorkspacedata(w_id[2]);
    if (res.status === 200) {
      setOneAccess(res.data.getOneAccessWorkspace[0]);
    }
  };

  const fetchPreConsole = () => {
    let headers = {
      "x-auth-token": auth,
      // 'Content-Type' : 'application/json'
    };
    console.log("Workspace ID:", w_id[2]);

    axios
      .get(`api/v1/consol/getAllConsolForConsol?workspaceID=${w_id[2]}`, {
        headers,
      })
      .then((response) => {
        console.log("Consol Data:", response.data.consolList);
        getAllPreConsolCompany(response.data.consolList);
      });
  };
  const getCompanyData = async () => {
    try {
      const response = await getProjectsConsol();
      setProjectsData(response.data.project);
    } catch (err) {
      console.log("err", err.response);
    }
  };
  const getAllIrData = async () => {
    const res = await fetchInvestmentRegistersConsol();
    if (res.status === 200) {
      setAllIR(res.data.investmentList);
    }
  };
//   const handleChangeValue = (e, field) => {
//     if (field === "parent_company") {
//     const result = allIr.filter(
//     (adj) => adj.companyID === e
//   );

//   setSelectedIr(result);
// }

//   };

// const handleChangeValue = (value, field) => {
//   setFsData((prev) => ({
//     ...prev,
//     [field]: value,
//   }));

//    if (field === "parent_company") {
//     const result = allIr.filter(
//       (adj) => adj.companyID === value  
//     );

//     setSelectedIr(result);
//   }
// };

const handleChangeValue = (value, field) => {
  setFsData((prev) => ({
    ...prev,
    [field]: value,
  }));
};

  // const handleSubmitFs = async () => {
  //   let data = {
  //      consol_name: fsData.consol_name,
  //      parent_company: fsData.parent_company,
  //      workspaceID: w_id[2],
  //      link_ir: fsData.link_ir,
  //      current_yr: workspaceData[0]?.console_cy,
  //      previous_yr: workspaceData[0]?.console_py,
  //      precet_id: uploadPresetID,
  //    };

  //   const res = await saveFsData(data);
  //   if (res.status === 200) {
  //     setOpen(false);
  //     fetchPreConsole();
  //     setUploadPresetId();
  //     dispatch(fetchWorkspacePrepareConsoleData(w_id[2]));
  //   }
  // };

  
    const handleSubmitFs = async () => {
    try {
    // let data ={
    //   consol_name: fsData.consol_name,
    //   parent_company: fsData.parent_company,
    //   link_ir: fsData.link_ir,
    //   fsType: fsData.fsType,          
    //   consolID: fsData.consolID,     
    //   precet_id: uploadPresetID,
    //   current_yr: fsData.current_yr,
    //   previous_yr: fsData.previous_yr,
    //   workSpaceId: w_id[2],
    // }

    let data = {
      consol_name: fsData.consol_name,
      parent_company: fsData.parent_company,
      link_ir: fsData.link_ir,
      FSType: fsData.FSType,
      current_yr: fsData.current_yr,
      previous_yr: fsData.previous_yr,
      workSpaceId: w_id[2],
    };

    if (fsData.FSType === "standalone") {
      data.precet_id = uploadPresetID;
    } else if (fsData.FSType === "consol") {
      data.consolID = fsData.consolID;
    }

    if (fsData.FSType === "standalone" && !uploadPresetID) {
      swal("Error", "Select Preset", "error");
      return;
    }

    if (fsData.FSType === "consol" && !fsData.consolID) {
      swal("Error", "Select Existing Consol", "error");
      return;
    }
 
    console.log("Submitting Payload:", data);

    const res = await axios.post(
      "api/v1/prepare-consol/create-fsGroup",
      data,
      {
        headers: {
          "x-auth-token": auth,
        },
      }
    );

    console.log("API Response:", res);
    if (res.status === 200) {
      swal("Success", "Consol FS Created Successfully", "success");
      setOpen(false);
      setTimeout(() => {
        fetchPreConsole();
      }, 500);
      setUploadPresetId("");
    }
  } catch (error) {
    console.log("Create Error:", error.response?.data || error);
    const errorMsg = error.response?.data?.msg || error.response?.data?.message || error.response?.data?.error || error.message || "Consol Not Created";
    swal("Error", errorMsg, "error");
  }
};

  const handleUpdateFs = async () => {
    try {
      let data = {
        consol_name: fsData.consol_name,
        parent_company: fsData.parent_company,
        link_ir: fsData.link_ir,
        current_yr: fsData.current_yr,
        previous_yr: fsData.previous_yr,
        workSpaceId: w_id[2],
      };

      console.log("Updating Payload for ID:", fsId, data);

      const res = await updateFsData(fsId, data);

      console.log("API Update Response:", res);
      if (res.status === 200) {
        swal("Success", "Consol FS Updated Successfully", "success");
        setEditOpen(false);
        setTimeout(() => {
          fetchPreConsole();
        }, 500);
      }
    } catch (error) {
      console.log("Update Error:", error.response?.data || error);
      const errorMsg = error.response?.data?.msg || error.response?.data?.message || error.response?.data?.error || error.message || "Consol FS Not Updated";
      swal("Error", errorMsg, "error");
    }
  };


  const getCompanyId = async (company_id) => {
    try {
      const response = await getCompanybyId(company_id);
      setCompany(response.data.getOneCompany[0].company_name);
    } catch (error) {
      console.log("getCompany", error.response);
    }
  };

  const handleIsOpen = (prepare_console) => {
    setIsOpen(true);
    getPreConsole(prepare_console._id);
    setPrepareConsoleID(prepare_console.link_company);
    dispatch(selectPrepareConsole(prepare_console));
  };
  const handleIsError = () => {
    swal("", "Please Upload Preset", "error");
  };
  const fetchWorskSpace = async () => {
    const res = await getWorkspace(w_id[2]);
    if (res.status === 200) {
      setWorkspace(res.data.getworkspace);
    }
  };

  const handleDeleteFs = async (id) => {
    const res = await deleteControlFS(id);
    if (res.status === 200) {
      fetchPreConsole();
      swal("", "Deleted Sucessful", "success");
      handleIdClose();
      dispatch(fetchWorkspacePrepareConsoleData(w_id[2]));
    }
  };

  const handleRenameConsolSubmit = async () => {
    if (!selectedConsolName.trim()) {
      swal("", "Please enter a consolidation name", "error");
      return;
    }
    try {
      const res = await axios.patch(
        `/api/v1/consol/renameConsol?consolID=${selectedConsolId}`,
        { name: selectedConsolName.trim() },
        {
          headers: {
            "x-auth-token": auth,
          },
        }
      );
      if (res.status === 200) {
        swal("", "Consolidation renamed successfully", "success");
        setRenameModalOpen(false);
        fetchPreConsole();
      } else {
        swal("", "Failed to rename consolidation", "error");
      }
    } catch (error) {
      console.error("Rename consolidation error:", error);
      swal("", "Failed to rename consolidation", "error");
    }
  };

  const handleDeleteConsolSubmit = async () => {
    try {
      const res = await axios.delete(
        `/api/v1/consol/deleteConsol?consolID=${deleteConsolId}`,
        {
          headers: {
            "x-auth-token": auth,
          },
        }
      );
      if (res.status === 200) {
        swal("", "Consolidation deleted successfully", "success");
        setDeleteModalOpen(false);
        fetchPreConsole();
      } else {
        swal("", "Failed to delete consolidation", "error");
      }
    } catch (error) {
      console.error("Delete consolidation error:", error);
      swal("", "Failed to delete consolidation", "error");
    }
  };

  const CompanyName = (c_id, field) => {
    const result = allCompany.filter((adj) => adj._id === c_id);
    if (field === "parent") {
      return result[0]?.company_name ? result[0]?.company_name : "-";
    } else {
      return result[0]?.company_name ? result[0]?.company_name : "-";
    }
  };
 const LinkIRName = (dat) => {
  if (dat?.investmentData?.name) {
    return dat.investmentData.name;
  }
  if (dat?.investmentRegisterID) {
    const result = allIr.filter((adj) => adj._id === dat.investmentRegisterID);
    return result[0]?.name || "NA";
  }
  return "NA";
};

  const ProjectName = (p_id) => {
    const result = projectsData.filter((adj) => adj._id === p_id);
    return result[0]?.project_name ? result[0]?.project_name : "";
  };

  const handleViewFS = (prepare_id, consolName) => {
    history.push(`/myfinV2/console-prepopulatefs/${prepare_id}`, {
    consolName: consolName,
    });
  };

  return (
    
    <div className={`${workSpaceCss.df}`} >
      <Sidebar />
      <div className={`d-flex ${commoncss.pageContent}`}>
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <Sidbarv2 w_id={w_id} />
        </motion.div>
        <div className={standalonecss.content}>

          <motion.div

            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={standalonecss.headerPadding}>
            <div
              // initial={{ y: -100, opacity: 0 }}
              // animate={{ y: 0, opacity: 1 }}
              // exit={{ y: 0, opacity: 0 }}
              // transition={{ duration: 0.5, ease: "easeInOut" }}
              className={standalonecss.headerContent}>
              <div style={{ width: "30rem", "z-index": "100" }}>
                <label className={commoncss.fs20}>Consolidated Financial Statements</label>
              </div>
              <div className='d-flex'>
                <>
                <Button
                  class_={commoncss.fs14}
                  btnColor={buttoncss.greyBg}
                  label="Translate FS"
                  onClick={() => setShowTranslateFSModal(true)}
                />&ensp;

                {showTranslateFSModal && (
                  <TranslateFSModal
                    mode="consol"
                    allProject={allpreconsoldata}
                    setShowTranslateFSModal={setShowTranslateFSModal}
                  />
                )}

                  <Button
                    class_={commoncss.fs14}
                    btnColor={buttoncss.greyBg}
                    label="Compare"
                    onClick={handleOpenCompare}
                  />&ensp;
                  {oneAccess?.access === "View" ? (

                    <Button
                      class_={commoncss.fs14}
                      btnColor={buttoncss.primary}
                      label="Create Consol FS"
                      icon={<PlusIcon />}
                      isEnabled={false} />

                  ) : (

                    <Button
                      class_={commoncss.fs14}
                      btnColor={buttoncss.primary}
                      icon={<PlusIcon />}
                      label="Create Consol FS"
                      onClick={handleOpen}
                    />
                  )}
                </>

              </div>
            </div>
          </motion.div>
          <motion.div

            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={`${standalonecss.fsTableContainer} mt-3`}
          >

            {/* {workspacePrepareConsol.loading ||
              !workspacePrepareConsol.response.consolList ? (
              <LoaderTwo />
            ) : workspacePrepareConsol.isSuccess &&
              workspacePrepareConsol?.response?.consolList?.length >
              0 ? (
              <>
                <div className={standalonecss.standaloneTableContainer}>
                  <table className={standalonecss.standaloneTable}>
                    <thead>
                      <tr>
                        <th >CONSOL NAME</th>
                        <th >PARENT COMPANY</th>
                        <th >PARENT COMPANY PRESET</th>
                        <th className="text-center">INVESTEES</th>
                        <th>INVESTMENT REGISTER</th>
                        <th className="text-center">VIEW FS</th>
                        {/* <th align="center">ACTION</th> */}
                      {/* </tr>
                    </thead>
                    <tbody>
                      {workspacePrepareConsol?.response?.consolList?.map(
                        (dat, index) => (
                          <tr
                            key={index} 
                           onClick={() => ViewobjMore(obj._id)}
                          >*/}
                            {/* <td
                            >
                              {dat.prepare_consol_company_name}
                            </td>
                            <td
                            >
                              {CompanyName(dat?.parent_company, "parent")}
                            </td>
                            <td
                            >
                              {dat?.upload_preset ? (
                                ProjectName(dat?.upload_preset)
                              ) : (
                                <Button
                                  btnColor={buttoncss.secondary}
                                  class_={commoncss.p5}
                                  label="Upload Preset"
                                  onClick={() =>
                                    uploadPreset("empty", dat._id)
                                  }
                                />
                              )}
                            </td>
                            <td className="text-center"
                            >
                              {dat?.upload_preset ? (
                                <EditIcon width={18} height={18} onClick={() => handleIsOpen(dat)} />
                              ) : (
                                <EditIcon width={18} height={18} onClick={() => handleIsError()} />
                              )}
                            </td>
                            <td
                            >
                              {LinkIRName(dat.link_company)}
                            </td>
                            <td className="text-center"
                            >
                              <Button
                                btnColor={buttoncss.secondary}
                                class_={commoncss.p5}
                                label="View FS"
                                onClick={() => handleViewFS(dat._id)}
                              />
                            </td> */}
                            {/* <td
                              >
                                <MoreVertIcon
                                  onClick={(e) => handleIdClick(e, dat._id)}
                                />
                                <Popover
                                  id={id}
                                  open={idopen}
                                  anchorEl={anchorEl}
                                  onClose={handleIdClose}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                >
                                  <Typography sx={{ p: 2 }}>
                                    <span
                                      style={{ cursor: "pointer", fontSize: "12px" }}
                                    >Edit</span>  <br />
                                    <span
                                      onClick={() => handleDeleteFs(fsId)}
                                      style={{ cursor: "pointer", fontSize: "12px" }}
                                    >
                                      Delete
                                    </span>
                                  </Typography>
                                </Popover>
                              </td> */}
                        {/*}  </tr>
                        )
                      )}

                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <>
                <div className="d-flex justify-content-between mt-4">
                  <p className="dm-sans fs-head">No Consolidated Financial Statements</p>
                </div>
              </>
            )} */}

           <div className={standalonecss.standaloneTableContainer}>
            <table className={standalonecss.standaloneTable}>
              <thead>
                <tr>
                  <th style={{ width: "28%" }}>CONSOL NAME</th>
                  <th style={{ width: "17%" }}>PARENT COMPANY</th>
                  <th style={{ width: "17%" }}>PARENT COMPANY PRESET</th>
                  <th style={{ width: "17%", textAlign: "center" }}>INVESTEES</th>
                  <th style={{ width: "17%" }}>INVESTMENT REGISTER</th>
                  <th style={{ width: "4%", textAlign: "right", paddingRight: "20px" }}>{" "}</th>
                </tr>
              </thead>

               <tbody>
               {allpreconsoldata.length > 0 ? (
                allpreconsoldata.map((dat) => (
                 <tr key={dat._id}>
                  <td style= {{ cursor: "pointer"}} onClick={() => handleViewFS(dat._id, dat.name)}>
                   {dat?.name?.trim() ? dat.name : "NA"}
               </td>

               <td>
                 {dat?.parentCompanyData?.company_name ||
                   CompanyName(dat?.parentCompanyID, "parent") ||
                   "NA"}
               </td>


                 <td>
                   {dat?.upload_preset || dat?.standaloneID ? (
                     ProjectName(dat?.upload_preset || dat?.standaloneID)
                   ) : (
                     <Button
                       btnColor={buttoncss.secondary}
                       class_={commoncss.p5}
                       label="Upload Preset"
                       onClick={() => uploadPreset("empty", dat._id)}
                     />
                   )}
                 </td>

                 <td style={{ textAlign: "center" }}>
                   {dat?.upload_preset || dat?.standaloneID ? (
                     <EditIcon
                       width={18}
                       height={18}
                       onClick={() => handleIsOpen(dat)}
                       style={{ cursor: "pointer" }}
                     />
                   ) : (
                     <EditIcon
                       width={18}
                       height={18}
                       onClick={() => handleIsError()}
                       style={{ cursor: "pointer" }}
                     />
                   )}
                 </td>

                 <td>{getInvestmentRegisterName(dat)}</td>

                 <td style={{ cursor: "pointer", textAlign: "right", paddingRight: "20px", verticalAlign: "middle" }}>
                   <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                     <MenuDotIcon onClick={(e) => handleIdClick(e, dat._id)} style={{ cursor: "pointer" }} />
                   </div>
                 </td>
                 <Popover
                 id={id}
                 open={idopen && fsId === dat._id}
                 anchorEl={anchorEl}
                 onClose={handleIdClose}
                 anchorOrigin={{
                   vertical: "bottom",
                   horizontal: "right",
                 }}
                 transformOrigin={{
                   vertical: "top",
                   horizontal: "right",
                 }}
                 PaperProps={{
                   sx: {
                     borderRadius: "10px",
                     boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                     minWidth: "160px",
                     padding: "6px 0",
                   },
                 }}
               >
               <div style={{ display: "flex", flexDirection: "column" }}>
                 
                 <div
                   onClick={() => {
                     handleIdClose();
                     if (user.responsibilities === "approver" || user.responsibilities === "view") {
                       swal("Warning", "You Don't have Access to Edit Consol FS", "warning");
                     } else {
                       setSelectedConsolId(dat._id);
                       setSelectedConsolName(dat.name || "");
                       setRenameModalOpen(true);
                     }
                   }}
                   style={{
                     padding: "5px 14px",
                     fontSize: "13px",
                     cursor: "pointer",
                     color: "#4D6D64",
                     fontWeight: "400",
                   }}
                   onMouseEnter={(e) => (e.target.style.background = "#f8f9f9")}
                   onMouseLeave={(e) => (e.target.style.background = "transparent")}
                 >
                     Edit Consol
                   </div>

                   <div
                     style={{
                       height: "1px",
                       background: "#eee",
                       margin: "4px 0",
                     }}
                   />

                     <div
                       onClick={() => {
                         handleIdClose();
                         if (user.responsibilities === "approver" || user.responsibilities === "view") {
                           swal("Warning", "You Don't have Access to Delete Consol FS", "warning");
                         } else {
                           setDeleteConsolId(dat._id);
                           setDeleteModalOpen(true);
                         }
                       }}
                       style={{
                         padding: "5px 14px",
                         fontSize: "13px",
                         cursor: "pointer",
                         color: "#4D6D64",
                         fontWeight: "400",
                       }}
                       onMouseEnter={(e) => (e.target.style.background = "#f8f9f9")}
                       onMouseLeave={(e) => (e.target.style.background = "transparent")}
                     >
                       Delete Consol
                     </div>

                   </div>
                 </Popover>

                
                

                {/* <td className="text-center">
                  <Button
                    btnColor={buttoncss.secondary}
                    class_={commoncss.p5}
                    label="View FS"
                    onClick={() => handleViewFS(dat._id, dat.name)}
                  />
                </td> */}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No Consolidated Financial Statements Found
              </td>
            </tr>
          )}
        </tbody>
        </table>
     </div>
    </motion.div>
        </div>
      </div>
      {editOpen && (
      <Modal
        title="Edit Consol FS"
        width="40%"
        bodycss={commoncss.unsetPadding}
        headerActions={
          <CloseIcon
            onClick={() => setEditOpen(false)}
            className="clickable"
          />
        }
        onClose={() => setEditOpen(false)}
        footerActions={
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%"}}>
            <Button
              btnColor={buttoncss.primary}
              label="Update"
              onClick={handleUpdateFs}
            />
          </div>
        }
      >
        <div className={commoncss.pd1530}>

          <InputGroup
            class_="mb-2"
            label="Consol Name"
            inputs={[
              <input
                placeholder="Enter Consol Name"
                value={fsData.consol_name}
                onChange={(e) =>
                  handleChangeValue(e.target.value, "consol_name")
                }
              />,
            ]}
          />

          <Dropdown
            label="Parent Company"
            options={allCompany.map((c) => ({
              label: c.company_name,
              value: c._id,
            }))}
            selValue={fsData.parent_company}
            onSelect={(opt) =>
              handleChangeValue(opt.value, "parent_company")
            }
            placeHolder="Select Parent Company"
          />

          <Dropdown
            label="Investment Register"
            options={allIr.map((ir) => ({
              label: ir.name,
              value: ir._id,
            }))}
            selValue={fsData.link_ir}
            onSelect={(opt) =>
              handleChangeValue(opt.value, "link_ir")
            }
            placeHolder="Select Investment Register"
          />

        <div style={{ display: "flex", gap: "16px", width: "100%", flexWrap: "wrap" }}>

          <div style={{ flex: 1, minWidth: "220px" }}>
            <InputGroup
              label="Current financial year"
              inputs={[
                <div style={{ position: "relative", width: "100%" }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      open={openCurrent}
                      onOpen={() => setOpenCurrent(true)}
                      onClose={() => setOpenCurrent(false)}
                      value={currentFY}
                      onChange={(value) => {
                        if (!value) return;
                        setCurrentFY(value);
                        handleChangeValue(
                          value.format("YYYY-MM-DD"),
                          "current_yr"
                        );
                        setOpenCurrent(false);
                      }}
                      format="DD-MMM-YYYY"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          onClick: () => setOpenCurrent(true),
                          InputProps: {
                            disableUnderline: true,
                          },
                          sx: {
                            "& fieldset": { border: "none" },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>

                  <div
                    onClick={() => setOpenCurrent(true)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    <CalenderIcon width={20} height={20} />
                  </div>
                </div>,
              ]}
            />
          </div>

          <div style={{ flex: 1, minWidth: "220px" }}>
            <InputGroup
              label="Previous financial year"
              inputs={[
                <div style={{ position: "relative", width: "100%" }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      open={openPrevious}
                      onOpen={() => setOpenPrevious(true)}
                      onClose={() => setOpenPrevious(false)}
                      value={previousFY}
                      onChange={(value) => {
                        if (!value) return;
                        setPreviousFY(value);
                        handleChangeValue(
                          value.format("YYYY-MM-DD"),
                          "previous_yr"
                        );
                        setOpenPrevious(false);
                      }}
                      format="DD-MMM-YYYY"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          onClick: () => setOpenPrevious(true),
                          InputProps: {
                            disableUnderline: true,
                          },
                          sx: {
                            "& fieldset": { border: "none" },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>

                  <div
                    onClick={() => setOpenPrevious(true)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    <CalenderIcon width={20} height={20} />
                  </div>
                </div>,
              ]}
            />
          </div>
        </div>
        </div>
        </Modal>
      )}
     
      <PreSetWorkspaceModal
        handleClose={handleClosePreset}
        open={preset}
        prepareConsoleId={setUploadPresetId}
        workspaceData={workspaceData}
        // selectedPresetProject={selectedPresetProject?.project_id}
        // setPresetHandler={setSelectedPresetProject}
        projectsData={projectsData}
        fieldModal={fieldModal}
        setOpen={setOpen}
        presetId={presetId}
      />
      {open && (
        <CreateFsModal
          open={open}
          handleClose={handleClose}
          handleChangeValue={handleChangeValue}
          allCompany={allCompany}
          selectedIr={allIr}
          uploadPreset={uploadPreset}
          uploadPresetID={uploadPresetID}
          handleSubmitFs={handleSubmitFs}
          workspaceData={workspaceData}
          ProjectName={ProjectName}
          fsData={fsData}
          projectsData={projectsData}
          setUploadPresetId={setUploadPresetId}
          consolList={allpreconsoldata}
        />
      )}

      <SubsidiarySelectModal
        isopen={isopen}
        handleIsClose={handleIsClose}
        value={value}
        handleChange={handleChange}
        presetIdData={presetIdData}
        workspaceData={workspaceData}
        prepareConsoleId={prepareConsoleId}
        CompanyName={CompanyName}
      />
      {openCompare && (
        <CompareFs
          open={openCompare}
          handleClose={handleIsClose}
          w_id={w_id}
          allpreconsoldata={allpreconsoldata}
        />
      )}

      <MuiModal
        open={renameModalOpen}
        onClose={() => setRenameModalOpen(false)}
        aria-labelledby="rename-modal-title"
        aria-describedby="rename-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "500px",
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
            padding: "0px 28px 28px 28px",
            outline: "none",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            fontFamily: '"DM Sans", sans-serif',
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginLeft: "-28px",
              marginRight: "-28px",
              paddingLeft: "28px",
              paddingRight: "28px",
              paddingTop: "14px",
              paddingBottom: "14px",
              borderBottom: "1px solid #eaeeed",
              fontFamily: '"DM Sans", sans-serif',
            }}
          >
            <Typography id="rename-modal-title" style={{ fontSize: "18px", fontWeight: "500", color: "#000000", letterSpacing: "1px" }}>
              Rename Consolidation
            </Typography>
            <MuiCloseIcon
              onClick={() => setRenameModalOpen(false)}
              style={{ cursor: "pointer", color: "#66827a", fontSize: "24px" }}
            />
          </div>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "8px", marginBottom: "10px" }}>
            <label style={{ fontSize: "12px", fontWeight: "400", color: "#205a46" }}>
              Enter Consol name
            </label>
            <input
              type="text"
              value={selectedConsolName}
              onChange={(e) => setSelectedConsolName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleRenameConsolSubmit();
                }
              }}
              autoFocus
              style={{
                width: "100%",
                height: "38px",
                padding: "10px 16px",
                border: "1.5px solid #c2e6d1",
                borderRadius: "8px",
                fontSize: "15px",
                color: "#333333",
                background: "#f4faf5",
                outline: "none",
              }}
            />
          </div>
          
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
            <button
              onClick={() => setRenameModalOpen(false)}
              className={`${buttoncss.custom_btn} ${buttoncss["custom-btn"]} ${buttoncss.secondary}`}
              style={{
                height: "38px",
                minWidth: "90px",
                cursor: "pointer",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleRenameConsolSubmit}
              className={`${buttoncss.custom_btn} ${buttoncss["custom-btn"]} ${buttoncss.primary}`}
              style={{
                height: "38px",
                minWidth: "90px",
                cursor: "pointer",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "15px",
              }}
            >
              Update
            </button>
          </div>
        </Box>
      </MuiModal>

      <MuiModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "500px",
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
            padding: "36px",
            outline: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", textAlign: "center", marginTop: "12px" }}>
            <Typography id="delete-modal-title" style={{ fontSize: "22px", fontWeight: "600", color: "#111111" }}>
              Are you sure?
            </Typography>
            <Typography style={{ fontSize: "16px", color: "#66827a", fontWeight: "400" }}>
              Once deleted, you will not be able to view the consolidation
            </Typography>
          </div>
          
          <div style={{ display: "flex", justifyContent: "center", gap: "26px", marginTop: "10px" }}>
            <button
              onClick={() => {
                setDeleteModalOpen(false);
                handleDeleteConsolSubmit();
              }}
              className={`${buttoncss.custom_btn} ${buttoncss["custom-btn"]} ${buttoncss.dangerDeleteModelBtn}`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                height: "38px",
                minWidth: "120px",
                background: "#e30000",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "13px",
                cursor: "pointer",
                padding: "10px 16px",
              }}
            >
              <DeleteIconWhite style={{ width: "16px", height: "16px" }} />
              Delete
            </button>
            <button
              onClick={() => setDeleteModalOpen(false)}
              className={`${buttoncss.custom_btn} ${buttoncss["custom-btn"]} ${buttoncss.deleteModelBtn_secondary_del}`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "38px",
                minWidth: "100px",
                background: "#ffffff",
                color: "#205a46",
                border: "1px solid #c2e6d1",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "13px",
                cursor: "pointer",
                padding: "10px 18px",
              }}
            >
              Cancel
            </button>
          </div>
        </Box>
      </MuiModal>

    </div>
  );
};

export default Consolidation;
